import { memo } from 'react';
import type { ColorFilterViewModel } from 'autogen/swagger/all';
import FilterMenuDrawer from '../../FilterMenu/FilterMenuDrawer';
import useFilterMenu from '../../FilterMenu/shared/hooks/useFilterMenu';
import ColorFilterOption from './ColorFilterOption';

const ColorFilterMenu = ({
    model: {
        displayName,
        options,
        queryStringName,
        attribute: { id }
    }
}: {
    model: ColorFilterViewModel;
}) => {
    const filterMenuId = id.toString();
    const { closeFilterMenu } = useFilterMenu(filterMenuId);
    return (
        <FilterMenuDrawer id={filterMenuId} headline={displayName} backButtonCallback={closeFilterMenu}>
            {options.map((option) => (
                <ColorFilterOption
                    key={option.displayName}
                    model={option}
                    queryStringName={queryStringName}
                    menuDisplayName={displayName}
                />
            ))}
        </FilterMenuDrawer>
    );
};

export default memo(ColorFilterMenu);
